<div class="ds-form-field" [class.has-error]="shouldShowError">
  <div class="ds-error-box" *ngIf="shouldShowError"></div>

  <!-- Error text above label -->
  <div *ngIf="errorMessage && shouldShowError" class="ds-error-text" role="alert">
    {{ errorMessage }}
  </div>

  <label *ngIf="showLabel" [for]="fieldId" class="ds-field-label">
    {{ label }} <span *ngIf="required" class="ds-required-asterisk">*</span>
  </label>

  <div class="ds-input-wrapper">
    <select
      class="ds-form-select form-select"
      [formControl]="control"
      [id]="fieldId"
      [required]="required"
      (change)="onSelectionChange($event)">

      @if (placeholder) {
        <option value="" [selected]="!control.value">{{ placeholder }}</option>
      }
      @for (state of states; track $index) {
        <option
          [value]="state"
          [selected]="control.value === state">
          {{ state }}
        </option>
      }
    </select>
  </div>
</div>
